import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppVersionService {
  private readonly storageKey = 'vm_app_build_id';
  private checking = false;
  private started = false;

  start(): void {
    if (this.started) {
      return;
    }
    this.started = true;
    this.check(false);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        this.check(true);
      }
    });
  }

  private check(reloadIfStale: boolean): void {
    if (this.checking) {
      return;
    }
    this.checking = true;
    fetch('assets/version.json', { cache: 'no-store' })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        const id = data?.buildId;
        if (!id) {
          return;
        }
        let previous = '';
        try {
          previous = sessionStorage.getItem(this.storageKey) || '';
        } catch (e) {}
        if (previous && previous !== id && reloadIfStale) {
          try {
            sessionStorage.setItem(this.storageKey, id);
          } catch (e) {}
          window.location.reload();
          return;
        }
        try {
          sessionStorage.setItem(this.storageKey, id);
        } catch (e) {}
      })
      .catch(() => {})
      .finally(() => {
        this.checking = false;
      });
  }
}
